<cyno-tabset customClass="tabset tabset--dark">
    <cyno-tab tabTitle="Wel verzekerd" [active]="true">
        <div class="h4">Binnen uw woning</div>
        <p>
            Schade aan uw spullen door bijvoorbeeld brand, storm, bliksem, water (zoals regen of hagel), diefstal,
            inbraak en vandalisme. Ook spullen die u leent, huurt of voor een bedrijf of uw werk gebruikt zijn
            verzekerd.
        </p>
        <div class="h4">Buiten uw woning</div>
        <p>
            In Nederland zijn uw spullen ook buiten uw woning verzekerd. Zoals tijdens vervoer en verhuizing. Of als de
            spullen bijvoorbeeld staan in:
        </p>
        <list-flat icon="check" [svg]="true">
            <list-flat-item>Uw garage, berging of schuur</list-flat-item>
            <list-flat-item>Bij uw woning uw auto, boot, caravan of camper</list-flat-item>
            <list-flat-item>Een opslagruimte of vakantiewoning</list-flat-item>
            <list-flat-item>
                In uw tuin of op het balkon zijn losse spullen verzekerd, zoals tuinmeubelen, tuindecoratie, barbecues
                en handgereedschap
            </list-flat-item>
        </list-flat>
        <p>
            Heeft u een schade die wij vergoeden?
            <br />
            Dan bent u ook verzekerd voor extra (noodzakelijke) kosten:
        </p>
        <list-flat icon="check" [svg]="true">
            <list-flat-item>Om verdere schade te voorkomen of te beperken</list-flat-item>
            <list-flat-item>Voor tijdelijke opslag van uw spullen</list-flat-item>
            <list-flat-item>Voor een tijdelijke vervangende woonruimte</list-flat-item>
            <list-flat-item>Om beschadigde spullen af te voeren</list-flat-item>
            <list-flat-item>Om sloten binnen 24 uur na diefstal van uw huissleutels te vervangen</list-flat-item>
        </list-flat>
        <!-- prettier-ignore -->
        <p>
            Bovenstaande is een samenvatting van onze dekking. Hoe u precies bent verzekerd staat
            <ins-pdf-link [pdfLink]="documentsEnum.ConditionsHomeInsurance"
                          pdfLinkTitle="Voorwaarden Woonverzekering">in onze voorwaarden</ins-pdf-link>.
        </p>
    </cyno-tab>
    <cyno-tab tabTitle="Niet verzekerd">
        <p>Niet verzekerd is schade door onder andere:</p>
        <list-flat icon="dot" [svg]="true">
            <list-flat-item>(Poging tot) diefstal buiten uw woning zonder sporen van braak</list-flat-item>
            <list-flat-item>Normaal gebruik (slijtage)</list-flat-item>
            <list-flat-item>Montage- of installatiefouten</list-flat-item>
            <list-flat-item>Een fout in het product zelf</list-flat-item>
            <list-flat-item>Onvoldoende of slecht onderhoud</list-flat-item>
            <list-flat-item>Openstaande ramen, deuren, lichtkoepels of luiken</list-flat-item>
            <list-flat-item>Het kwijtraken van spullen</list-flat-item>
        </list-flat>
        <p>Niet verzekerd, maar wel aanvullend te verzekeren:</p>
        <list-flat icon="dot" [svg]="true">
            <list-flat-item>
                Val- en stootschade aan mobiele apparaten. Dit is wel verzekerd met onze Mobiele Elektronica dekking
            </list-flat-item>
            <list-flat-item>
                Schade door uw eigen schuld of doordat u, iemand uit uw gezin of uw huisdier iets omstoot of laat
                vallen. Dit is wel verzekerd met onze Compleetdekking
            </list-flat-item>
            <list-flat-item>
                Schade aan glas. Dit is wel aanvullend te verzekeren met onze
                <a routerLink="/woonverzekering/glasverzekering">Glasverzekering</a>
            </list-flat-item>
        </list-flat>
        <!-- prettier-ignore -->
        <p>
            Bovenstaande is een samenvatting van onze dekking. Hoe u precies bent verzekerd staat
            <ins-pdf-link [pdfLink]="documentsEnum.ConditionsHomeInsurance"
                          pdfLinkTitle="Voorwaarden Woonverzekering">in onze voorwaarden</ins-pdf-link>.
        </p>
    </cyno-tab>

    <cyno-tab tabTitle="Verzekerde bedragen">
        <h2>Verzekerde bedragen</h2>
        <p>
            Voor de meeste spullen geldt geen maximaal verzekerd bedrag. Maar niet voor alles. Spullen waarvoor een
            maximum vergoeding geldt zijn bijvoorbeeld:
        </p>
        <list-flat icon="dot" [svg]="true">
            <list-flat-item>€ 20.000 voor audio- en computerapparatuur</list-flat-item>
            <list-flat-item>€ 35.000 voor verzamelingen, kunst, antiek en muziekinstrumenten</list-flat-item>
            <list-flat-item>€ 6.000 voor sieraden (€ 8.000 met onze Compleetdekking)</list-flat-item>
            <list-flat-item>€ 25.000 voor spullen in uw tuin</list-flat-item>
            <list-flat-item>€ 5.000 voor spullen die u leent of huurt</list-flat-item>
            <list-flat-item>€ 10.000 voor spullen in uw garage, berging of schuur</list-flat-item>
            <list-flat-item>€ 7.500 voor spullen in uw vakantiewoning</list-flat-item>
            <list-flat-item>€ 750 voor spullen in uw auto, camper, caravan of boot</list-flat-item>
        </list-flat>
        <p>
            Bovenstaande is een samenvatting van onze dekking. Hoe u precies bent verzekerd staat
            <ins-pdf-link [pdfLink]="documentsEnum.ConditionsHomeInsurance" pdfLinkTitle="Voorwaarden Woonverzekering">
                in onze voorwaarden
            </ins-pdf-link>
            .
        </p>
    </cyno-tab>

    <cyno-tab tabTitle="Eigen Risico">
        <p>
            Bij onze Inboedelverzekering is het eigen risico standaard €&nbsp;0. Maar in ruil voor een lagere premie
            kunt u kiezen voor een eigen risico van €&nbsp;150. Bij schade door storm is uw eigen risico €&nbsp;200.
        </p>
        <table class="table table--primary">
            <thead>
                <tr>
                    <th></th>
                    <th>Standaard eigen risico</th>
                    <th>Hoger eigen risico (met lagere premie)</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Eigen risico:</td>
                    <td class="table__center">€&nbsp;0</td>
                    <td class="table__center">€&nbsp;150</td>
                </tr>
                <tr>
                    <td>Eigen risico stormschade:</td>
                    <td class="table__center">€&nbsp;200</td>
                    <td class="table__center">€&nbsp;200</td>
                </tr>
            </tbody>
        </table>
    </cyno-tab>
</cyno-tabset>
